import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';

// TinyMCE is large: it is loaded in a separate chunk only on pages with an editor.
const HTMLTextArea = lazy(() => import('../../components/HTMLTextArea'));
import FieldError from '../../components/FieldError';


const renderHtmlTextArea = (
  {
    input: { value, onChange, onBlur },
    meta: { touched, error },
    label,
    componentName,
  },
) => {
  const handleInput = (content) => {
    onChange(content);
  };
  return (
    <FormGroup noMargin className="form-group">
      <Label>{label}</Label>
      <Suspense fallback={<div className="html-text-area-loading">Загрузка редактора...</div>}>
        <HTMLTextArea
          name={componentName}
          initialValue={value || ''}
          onChange={handleInput}
          onBlur={onBlur}
        />
      </Suspense>
      {touched && error && <FieldError error={error} />}
    </FormGroup>
  );
};


renderHtmlTextArea.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  componentName: PropTypes.string.isRequired,
};

export default renderHtmlTextArea;
